import StepperProcessCard from './sections/StepperProcessCard';
import DemoCtaCard from './sections/DemoCtaCard';

const StartUsingSection = () => {
  const whatsappLink =
    "https://wa.me/919225296763?text=Hello%20Trrip%20Team!%20I'd%20like%20to%20book%20a%20demo%20for%20the%20Agent%20Portal.";

  return (
    <section className="py-16 px-4 md:px-8 lg:px-12 bg-white relative overflow-hidden">
      <div className="max-w-7xl 2xl:max-w-[1600px] mx-auto w-full flex flex-col lg:flex-row gap-6">
        {/* LEFT CARD: 5 Step Process */}
        <StepperProcessCard />

        {/* RIGHT CARD: Demo CTA */}
        <DemoCtaCard whatsappLink={whatsappLink} />
      </div>
    </section>
  );
};

export default StartUsingSection;
